import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class CancelEsipOrderUsecase extends BaseUseCase {
    constructor(repo) {
        super();
        this.repo = repo;
    }
    async fetchResult(req) {
        return await this.repo.cancelEsipOrder(req);
    }
}
export default CancelEsipOrderUsecase;
